import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, message, Modal, Row, Select, Space, Spin, Tag } from 'antd';
import PropTypes from 'prop-types';
import { GetAllAccounts } from '../../../../actions/AccountAction';
import { ROLES } from '../../../../constants/global';
import {
	getClientMessages,
	getCommissionMessages,
	getEmployeeMessages,
	getErrorMessages,
	getInvoicingMessages,
	getModalMessages,
} from '../../../../constants/messages';
import { searchInString } from '../../../../utilities/util';
import { EditSalesPersonClient } from '../../actions';

let modalMessages = getModalMessages(),
	errorMessages = getErrorMessages(),
	invoiceMessages = getInvoicingMessages(),
	commissionMessages = getCommissionMessages(),
	employeeMessages = getEmployeeMessages(),
	clientMessages = getClientMessages();

const messages = {
	...modalMessages,
	...errorMessages,
	...invoiceMessages,
	...commissionMessages,
	...employeeMessages,
	...clientMessages,
};

const SalesPersonModal = ({ showModal, handleCancel, salesPersonId, clientId }) => {
	const intl = useIntl();
	const dispatch = useDispatch();
	const [form] = Form.useForm();
	const roles = useSelector((state) => state.auth.roles);
	const [isSaving, setSaving] = useState(false);
	const [loading, setLoading] = useState(false);
	const [employeesAccount, setEmployeesAccount] = useState([]);

	const employeesOptions = employeesAccount.map((account) => {
		let Label = account.name;
		return {
			label: (
				<Row>
					<Col span={20}>
						<Space>{Label}</Space>
					</Col>
					<Col span={4} style={{ textAlign: 'center' }}>
						<Tag color={account.active ? 'success' : 'error'} style={{ width: '100%' }}>
							{account.active ? (
								<FormattedMessage {...messages.active} />
							) : (
								<FormattedMessage {...messages.inactive} />
							)}
						</Tag>
					</Col>
				</Row>
			),
			value: account.id,
			displayLabel: account.name,
			searchValue: account.name,
		};
	});

	useEffect(() => {
		const fetchData = async () => {
			try {
				const employeesAccount = await GetAllAccounts();
				setEmployeesAccount(employeesAccount);
				setLoading(false);
			} catch (error) {
				message.error(intl.formatMessage({ ...messages.commonError }));
			}
		};
		if (roles) {
			if (roles.includes(ROLES.MASTER) || roles.includes(ROLES.ADMINISTRATOR)) {
				fetchData();
			}
		}
	}, [roles]);

	const onOk = async () => {
		try {
			setSaving(true);
			const values = await form.validateFields();
			await dispatch(
				EditSalesPersonClient(
					{ newSalesPersonId: values.salesPersonId, oldSalesPersonId: salesPersonId },
					clientId
				)
			);
			message.success(intl.formatMessage({ ...messages.editSalesPersonClient }));
			handleCancel();
		} catch (error) {
			message.error(intl.formatMessage({ ...message.commonError }));
		} finally {
			setSaving(false);
		}
	};

	return (
		<Modal
			open={showModal}
			title={intl.formatMessage({ ...messages.Salesperson })}
			onOk={onOk}
			confirmLoading={isSaving}
			okText={intl.formatMessage({ ...messages.save })}
			onCancel={handleCancel}
			cancelText={intl.formatMessage({ ...messages.cancel })}
			destroyOnClose
		>
			<Spin spinning={loading}>
				<Form form={form} preserve={false} layout={'vertical'} className="login-form col-8">
					<Form.Item
						name="salesPersonId"
						initialValue={salesPersonId}
						rules={[
							{
								required: true,
								message: intl.formatMessage({ ...messages.salespersonRequiredError }),
							},
						]}
					>
						<Select
							showSearch
							placeholder={intl.formatMessage({ ...messages.Salesperson })}
							filterOption={(input, option) => searchInString(input, option.searchValue)}
							optionFilterProp="children"
							options={employeesOptions}
						/>
					</Form.Item>
				</Form>
			</Spin>
		</Modal>
	);
};

SalesPersonModal.propTypes = {
	showModal: PropTypes.bool,
	handleCancel: PropTypes.func,
	salesPersonId: PropTypes.number.isRequired,
	clientId: PropTypes.number.isRequired,
};

export default SalesPersonModal;
